exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settingsContainer-3c7a6712{position:relative;top:-4px;left:-322px}\n", ""]);

// Exports
exports.locals = {
	"settingsContainer": "settingsContainer-3c7a6712"
};